"use client";

import { useRouter } from "next/navigation";
import { Button, Heading, Text, Link, ImageWrapper } from "ui-components";

import { useCurrentLocale } from "@/src/hooks/useCurrentLocale";

export default function NotFound(): JSX.Element {
  const router = useRouter();
  const currentLocal = useCurrentLocale();

  return (
    <div className="flex flex-col justify-center items-center gap-5 my-10">
      <Heading className="text-center px-5">
        Sorry, we couldn&apos;t find this event
      </Heading>
      <div>
        <Text>
          The event you&apos;re looking for has expired or does not exist.&nbsp;
        </Text>
        <Link href={`/${currentLocal}/events`}>Browse our events listing</Link>
      </div>
      <Button onClick={() => router.push(`/${currentLocal}/events`)}>
        Browse events
      </Button>
      <ImageWrapper
        src="/not-found.png"
        width={555}
        height={500}
        alt="Event not found"
      />
    </div>
  );
}
